import React, { useEffect, useState } from "react";
import { withFirebase } from "../../firebase";
import { withRouter } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import PickupControl from "./pickupControl";

const PickupControlContainer = (props) => {
	const { t } = useTranslation();
	const cities = useSelector((state) => state.shops.shops);
	const currentCity = JSON.parse(localStorage.getItem("chosenCity"));
	const currentBrand = JSON.parse(localStorage.getItem("chosenBrand"));

	const adminPermission = JSON.parse(localStorage.getItem("adminPermission"));
	const isNewAdmin = adminPermission?.newAdmin;
	const deliveryTerminals = isNewAdmin
		? cities[currentCity]?.brands[currentBrand]?.deliveryTerminals
		: cities[currentCity]?.deliveryTerminals;

	const [terminals, setTerminals] = useState(deliveryTerminals);

	const onSubmit = () => {
		const isValidTerminals = !!terminals.find((item) => item.isActive === true);
		const ref = isNewAdmin
			? `/web/settings/city/${currentCity}/brands/${currentBrand}/deliveryTerminals`
			: `/web/settings/city/${currentCity}/deliveryTerminals`;
		if (isValidTerminals) {
			props.firebase.bd
				.ref(ref)
				.update(terminals)
				.then(() => {
					alert(t("common.done"));
				})
				.catch((error) => {
					console.error("Error updating terminals:", error);
					alert(t("pickupControl.error"));
				});
		} else {
			alert(t("pickupControl.minActiveTerminal"));
		}
	};

	useEffect(() => {
		deliveryTerminals && setTerminals(deliveryTerminals);
	}, [deliveryTerminals]);

	return (
		<div>
			{terminals && (
				<PickupControl
					terminals={terminals}
					setTerminals={setTerminals}
					saveData={onSubmit}
				/>
			)}
		</div>
	);
};

export default withRouter(withFirebase(PickupControlContainer));
